module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0044.jpg?v=e997af7e";